<div class="app-form-item-group">
  <label *ngIf="title" class="app-form-item-group-label">{{ title }}</label>
  <div class="content" [ngClass]="{'move-up': title}">
    <ng-content></ng-content>
  </div>
</div>
